import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MotivosCancelamentoService {
  BASEURL: string;
  httpHeaders: HttpHeaders;

  constructor(private http: HttpClient) {
    this.BASEURL = environment.apiUrl;

    this.httpHeaders = new HttpHeaders({
      Authorization: localStorage.getItem('tokenMappe'),
    });
  }

  listaMotivoCancelamento(): Observable<any> {
    return this.http.get(`${this.BASEURL}/cancel-reason`, {
      headers: this.httpHeaders,
    });
  }

  listaItemMotivoCancelamento(id: string): Observable<any> {
    return this.http.get(`${this.BASEURL}/cancel-reason/${id}`, {
      headers: this.httpHeaders,
    });
  }

  salvaMotivoCancelamento(body: any): Observable<any> {
    return this.http.post(`${this.BASEURL}/cancel-reason`, body, {
      headers: this.httpHeaders,
    });
  }

  editarItemMotivoCancelamento(id: string, body: any): Observable<any> {
    return this.http.put(`${this.BASEURL}/cancel-reason/${id}`, body, {
      headers: this.httpHeaders,
    });
  }

  excluirItemMotivoCancelamento(id: string): Observable<any> {
    return this.http.delete(`${this.BASEURL}/cancel-reason/${id}`, {
      headers: this.httpHeaders,
    });
  }
}
